/**
 * Utilitaire de validation et sanitization des URLs
 * Protection contre les injections XSS via javascript:, data:, etc.
 */

const ALLOWED_PROTOCOLS = ['http:', 'https:', 'blob:'];

/**
 * Valide et sanitize une URL pour éviter les injections XSS
 * @param url - URL à valider (peut être null/undefined)
 * @returns URL validée ou null si invalide/dangereuse
 */
export function sanitizeUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    // Seuls les protocoles sûrs sont autorisés
    if (ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
      return url;
    }
    // Protocole non autorisé (javascript:, data:, vbscript:, etc.)
    console.warn('[Security] URL bloquée - protocole non autorisé:', parsed.protocol);
    return null;
  } catch {
    // URL relative ou invalide
    if (url.startsWith('/') || url.startsWith('#') || url.startsWith('./')) {
      return url; // URLs relatives sont OK
    }
    console.warn('[Security] URL invalide bloquée:', url.substring(0, 50));
    return null;
  }
}

/**
 * Vérifie qu'une URL est bien un domaine Stripe valide
 * @param url - URL à vérifier
 * @returns true si l'URL est un domaine Stripe
 */
export function isValidStripeUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    // Vérifier que c'est bien un domaine Stripe
    return (
      parsed.protocol === 'https:' &&
      (parsed.hostname === 'checkout.stripe.com' ||
       parsed.hostname === 'billing.stripe.com' ||
       parsed.hostname.endsWith('.stripe.com'))
    );
  } catch {
    return false;
  }
}
